import { LocalityTableDTO } from '../../../Domain/DTO/LocalityTableDTO';

export class ZoneHelperProps{
    Localities: Array<LocalityTableDTO>
    LocalitiesOriginal: Array<LocalityTableDTO>
}

export const InitialZoneHelperProps: ZoneHelperProps = { Localities: [], LocalitiesOriginal: []};